import { ReactElement } from 'react';
import { connect } from 'react-redux';
import MyBookmarkPage from 'pages/bookmark/MyBookmarkPage';
import { IStoreState } from 'store';
import { clearModalContent, setModalContent } from 'store/modal/actions';
import {
  getBookmarks,
  deleteBookmark,
  renameBookmark,
  setBookmarkName,
  setUserSearchInput,
} from 'store/bookmark/actions';
import { IBookmarkObjState } from 'store/bookmark/types';

interface TBookmarkPageStateProps {
  bookmarks: IBookmarkObjState[];
  bookmarkName: string;
  bookmarkLink: string;
  searchInputValue: string;
  renameBookmarkSuccess: boolean;
}

export interface TBookmarkPageDispatchProps {
  getBookmarks: () => void;
  clearModalContent: () => void;
  setModalContent: (content: ReactElement) => void;
  deleteBookmark: (id: string) => void;
  renameBookmark: (bookmarkObj: { name: string; link: string; module: string }) => void;
  setBookmarkName: (bookmarkName: string, bookmarkLink: string, bookmarkModule: string) => void;
  setUserSearchInput: (userInput: string) => void;
}

export type TBookmarkPageProps = TBookmarkPageStateProps & TBookmarkPageDispatchProps;

const mapStateToProps = (state: IStoreState): TBookmarkPageStateProps => ({
  bookmarks: state.bookmark.bookmarks,
  bookmarkName: state.bookmark ? state.bookmark.bookmarkName : '',
  bookmarkLink: state.bookmark ? state.bookmark.bookmarkLink : '',
  searchInputValue: state.bookmark ? state.bookmark.searchInputValue : '',
  renameBookmarkSuccess: state.bookmark ? state.bookmark.renameBookmarkSuccess : false,
});

const mapDispatchToProps = {
  getBookmarks,
  clearModalContent,
  setModalContent,
  deleteBookmark,
  renameBookmark,
  setBookmarkName,
  setUserSearchInput,
};

export default connect(mapStateToProps, mapDispatchToProps)(MyBookmarkPage);
